import { getAllAppointments, getAllAppointmentsByConnectedProvider } from '@ax/service';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export function useGetAllAppointmentsApi(
  doctorId: string,
  date: string,
  isProviderAdmin?: boolean,
  adminDoctorId?: string,
) {
  const memoizedIsProviderAdmin = useMemo(() => isProviderAdmin, [isProviderAdmin]);

  const query = useQuery({
    queryKey: ['appointments', date],
    queryFn: () =>
      memoizedIsProviderAdmin
        ? getAllAppointmentsByConnectedProvider({ doctorId, date, adminDoctorId })
        : getAllAppointments({ doctorId, date }),
    onError: (error: Error) => {
      console.log(error.message);
    },
    enabled: !!date,
    cacheTime: 0,
    refetchInterval: 5000,
  });
  return query;
}
